import { defineComponent, ref, inject } from 'vue';
import { vClickOutside } from '../../directives/click-outside/index.js';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UiDropdownMenu",
  props: {
    locale: { type: null, required: true },
    buttonText: { type: String, required: false }
  },
  setup(__props) {
    const props = __props;
    const isDialogOpen = ref(false);
    const toggleButton = ref();
    const toggleDialog = () => {
      isDialogOpen.value = !isDialogOpen.value;
    };
    const openDialog = () => {
      isDialogOpen.value = true;
    };
    const closeDialog = () => {
      isDialogOpen.value = false;
    };
    const localizationSupport = useLocalizationSupport(props, { translator: inject("translator") });
    const { translate } = localizationSupport;
    return { __sfc: true, props, isDialogOpen, toggleButton, toggleDialog, openDialog, closeDialog, localizationSupport, translate, vClickOutside };
  }
});

export { _sfc_main as default };
